import { Injectable } from '@angular/core';
const  imageCompression = require('browser-image-compression/dist/browser-image-compression.js');
import { Observable } from 'rxjs';


@Injectable()

export class CompressionService {

    constructor() { }

    async compressImage(imageFile: any, maxSizeMB: number)
    {
        var options = {
            maxSizeMB: maxSizeMB
          }
          try {
            const compressedFile = await imageCompression(imageFile, options);         
            return compressedFile;

          } catch (error) {
            console.log(`Error performing image compression: ${error}`);
          }
    }

}